import {View} from 'MWC';
import tpl from '../templates/desktop/apple-setup-card';

export default class extends View {
    template = tpl;

    // templateMobile = tplMobile;

    constructor() {
        super();
        this.state = {
            ui: this.uiStates.INITIAL,
            apw: true,
            ap24: false,
            apwch: false
        };

        this.toggle = this.toggle.bind(this);

        return this;
    }

    toggle(name) {
        const res = {
            apw: name === 'apw',
            ap24: name === 'ap24',
            apwch: name === 'apwch'
        };
        this.setState(res);
    }
}
